import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Warehouse } from 'app/models/warehouse.models';
import { AlmacenService } from 'app/services/almacen.service';
import { AddressAutocompleteService } from 'app/services/address-autocomplete.service';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { UserService } from 'app/services/user.service';
interface AddressPrediction {
  description: string;
  place_id: string;
}
@Component({
  selector: 'app-almacen-add-edit',
  templateUrl: './almacen-add-edit.component.html',
  styleUrls: ['./almacen-add-edit.component.css'],
})
export class AlmacenAddEditComponent implements OnInit {
  form: FormGroup;
  tipo: string;
  warehouse: Warehouse;
  searchTerm = new FormControl('');
  private searchSubject = new Subject<string>();
  predictions: AddressPrediction[] = [];
  isEditMode: boolean = false;
  usersList: string[] = [];
  warehouses: Warehouse[] = [];

  constructor(
    public dialogRef: MatDialogRef<AlmacenAddEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private almacenService: AlmacenService,
    private addressService: AddressAutocompleteService,
    private userService: UserService
  ) {
    this.tipo = data.tipo;
    this.warehouse = data.warehouse;
    this.warehouses = data.warehouses;
  }

  ngOnInit(): void {
    this.isEditMode = !!this.warehouse?.code;
    this.initForm();
    this.setupSearch();
    this.loadUsers();
  }

  initForm() {
    this.form = this.fb.group({
      code: [this.warehouse?.code || null],
      number: [
        {
          value: this.warehouse?.number || this.getNewWarehouseNumber(),
          disabled: this.warehouse?.number || this.getNewWarehouseNumber(),
        },
      ],
      name: [
        this.warehouse?.name || '',
        [Validators.required, Validators.maxLength(200)],
      ],
      address: [this.warehouse?.address || '', [Validators.maxLength(200)]],
      phone: [this.warehouse?.phone || '', [Validators.maxLength(45)]],
      email: [this.warehouse?.email || '', [Validators.email, Validators.maxLength(45)]],
      manager: [this.warehouse?.manager || '', [Validators.maxLength(150)]],
    });
  }

  loadUsers() {
    this.userService.getUsers().subscribe({
      next: (response: any) => {
        // Comprobamos si la respuesta tiene la estructura esperada con 'users' y 'total'
        const users = Array.isArray(response) ? response : response.users || [];
        this.usersList = users;
      },
      error: error => {
        console.error('Error cargando usuarios:', error);

        this.snackBar.open('Error al cargar la lista de usuarios', 'Cerrar', {
          duration: 3000,
        });
      },
    });
  }

  guardarAlmacen() {
    if (this.form.valid) {
      const warehouseData = this.form.getRawValue();

      if (this.warehouse) {
        // Actualizar almacén existente
        this.almacenService.updateAlmacen(this.warehouse.id, warehouseData).subscribe(
          (response: any) => {
            this.showMessage('Almacén actualizado correctamente');
            this.dialogRef.close(true);
          },
          (error: any) => {
            console.error('Error al actualizar el almacén:', error);
            this.showMessage('Error al actualizar el almacén', 'error');
          }
        );
      } else {
        // Crear nuevo almacén

        this.almacenService.saveAlmacen(warehouseData).subscribe(
          (response: any) => {
            this.showMessage('Almacén creado correctamente');
            this.dialogRef.close(true);
          },
          (error: any) => {
            console.error('Error al crear el almacén:', error);
            this.showMessage('Error al crear el almacén', 'error');
          }
        );
      }
    } else {
      this.showMessage('Por favor, complete todos los campos requeridos', 'error');

      // Marcar todos los controles como tocados para mostrar los errores
      Object.keys(this.form.controls).forEach(key => {
        this.form.get(key)?.markAsTouched();
      });
    }
  }

  cancelar() {
    this.dialogRef.close(false);
  }

  showMessage(message: string, type: 'success' | 'error' = 'success') {
    this.snackBar.open(message, 'Cerrar', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: type === 'error' ? ['error-snackbar'] : ['success-snackbar'],
    });
  }

  onSearch() {
    if (this.searchTerm.value) {
      this.searchSubject.next(this.searchTerm.value);
    }
  }

  setupSearch() {
    this.searchSubject
      .pipe(
        debounceTime(300),
        switchMap(term => this.addressService.getSuggestions(term))
      )
      .subscribe(results => {
        this.predictions = results;
      });
  }

  onAddressSelect(selectedAddress: string) {
    this.searchTerm.setValue(selectedAddress);
    this.form.get('address').setValue(selectedAddress);
    this.predictions = [];
  }

  onNameInput() {
    const nameControl = this.form.get('name');
    if (nameControl?.value?.length >= 200) {
      console.log(nameControl?.value?.length);
      nameControl.setValue(nameControl.value.substring(0, 200));
      nameControl.markAsTouched();
    }
  }

  getNewWarehouseNumber() {
    if (this.warehouses.length === 0) {
      return 1;
    }
    const lastElement = this.warehouses[this.warehouses.length - 1];
    const newWarehouseNumber = Number(lastElement.number) + 1;
    return newWarehouseNumber;
  }
}
